import React from "react";
import { Redirect, Switch, BrowserRouter as Router } from "react-router-dom";
import { connect } from "react-redux";
import { RouteWithLayout } from "./components";
import { Main as MainLayout, Minimal as MinimalLayout } from "./layouts";
import {
  Portfolio as PortfolioView,
  Account as AccountView,
  Settings as SettingsView,
  SignUp as SignUpView,
  SignIn as SignInView,
  Report as ReportView,
  History as HistoryView,
  Wall as WallView,
  NotFound as NotFoundView,
  Watchlist as WatchlistView,
  Suscription as SuscriptionView,
  Profile as ProfileView,
  Comment as CommentView,
  Recovery as RecoveryView,
  Reset as ResetView,
  Confirm as ConfirmView,
  Stock as StockView,
  StockChart as StockChartView,
  Discover as DiscoverView,
  Faq as FaqView,
  Knowledge as KnowledgeView,
  Balance as BalanceView,
  Alerts as AlertsView,
  MarketCalendar as MarketCalendarView,
} from "./views";
import Menu from "./menu";


//
const Routes = (props) => {
  if (!props.sessionReady) {
    return null;
  }

  const isAuthenticated = props.auth && Object.keys(props.auth).length > 0;

  return (// JSON.stringify()

    <Router basename="/" >
      {
        isAuthenticated ? (
          <Switch>
            <Redirect exact from="/" to={Menu.portfolio.url} />
            <RouteWithLayout
              component={PortfolioView}
              exact
              layout={MainLayout}
              path={Menu.portfolio.url}
            />
            <RouteWithLayout
              component={ReportView}
              exact
              layout={MainLayout}
              path={Menu.report.url}
            />
            <RouteWithLayout
              component={StockChartView}
              exact
              layout={MainLayout}
              path={Menu.stockChart.url}
            />
            <RouteWithLayout
              component={StockView}
              exact
              layout={MainLayout}
              path={Menu.stock.url}
            />
            <RouteWithLayout
              component={HistoryView}
              exact
              layout={MainLayout}
              path={Menu.history.url}
            />

            <RouteWithLayout
              component={BalanceView}
              exact
              layout={MainLayout}
              path={Menu.balance.url}
            />
            <RouteWithLayout
              component={WatchlistView}
              exact
              layout={MainLayout}
              path={Menu.watchlist.url}
            />
            <RouteWithLayout
              component={AlertsView}
              exact
              layout={MainLayout}
              path={Menu.alerts.url}
            />
            <RouteWithLayout
              component={MarketCalendarView}
              exact
              layout={MainLayout}
              path={Menu.calendar.url}
            />
            <RouteWithLayout
              component={WallView}
              exact
              layout={MainLayout}
              path={Menu.wall.url}
            />
            <RouteWithLayout
              component={CommentView}
              exact
              layout={MainLayout}
              path={Menu.comment.url}
            />
            <RouteWithLayout
              component={DiscoverView}
              exact
              layout={MainLayout}
              path={Menu.discover.url}
            />
            <RouteWithLayout
              component={FaqView}
              exact
              layout={MainLayout}
              path={Menu.faq.url}
            />
            <RouteWithLayout
              component={KnowledgeView}
              exact
              layout={MainLayout}
              path={Menu.knowledge.url}
            />
            <RouteWithLayout
              component={SuscriptionView}
              exact
              layout={MainLayout}
              path={Menu.suscription.url}
            />
            <RouteWithLayout
              component={ProfileView}
              exact
              layout={MainLayout}
              path={Menu.profile.url}
            />
            <RouteWithLayout
              component={AccountView}
              exact
              layout={MainLayout}
              path={Menu.account.url}
            />
            <RouteWithLayout
              component={SettingsView}
              exact
              layout={MainLayout}
              path={Menu.setting.url}
            />
            <RouteWithLayout
              component={SignInView}
              exact
              layout={MinimalLayout}
              path={Menu.exit.url}
            />
            <RouteWithLayout
              component={NotFoundView}
              exact
              layout={MinimalLayout}
              path="/not-found"
            />
            <Redirect to="/not-found" />

          </Switch>
        ) :
          (
            <Switch>
              <Redirect exact from="/" to={Menu.exit.url} />
              <RouteWithLayout
                component={SignInView}
                exact
                layout={MinimalLayout}
                path={Menu.exit.url}
              />
              <RouteWithLayout
                component={SignUpView}
                exact
                layout={MinimalLayout}
                path={Menu.signup.url}
              />
              <RouteWithLayout
                component={RecoveryView}
                exact
                layout={MinimalLayout}
                path={Menu.recovery.url}
              />
              <RouteWithLayout
                component={NotFoundView}
                exact
                layout={MinimalLayout}
                path={Menu.exit.url}
              />
              <RouteWithLayout
                component={ResetView}
                exact
                layout={MinimalLayout}
                path={Menu.reset.url}
              />
              <RouteWithLayout
                component={ConfirmView}
                exact
                layout={MinimalLayout}
                path={Menu.confirm.url}
              />

              <Redirect to={Menu.exit.url} />
            </Switch>
          )
      }
    </ Router>
  );
};



const mapStateToProps = (reducer) => {
  return {
    auth: reducer.session.auth,
    sessionReady: reducer.session.sessionReady,
  };
};


export default connect(mapStateToProps, null)(Routes);

